<template>
  <div>
    <h3 class="declined-title">
      We are unable to offer you a loan at this time.
    </h3>
    <p>
      Unfortunately, you do not currently meet our eligibility requirements. Thank you for taking the time to
      apply, and feel free to return in a few months to make another request.
    </p>
  </div>
</template>

<script>
export default {
  name: "Declined"
};
</script>

<style scoped>

</style>
